<template>
  <form>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
            <v-subheader>Department</v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
            <span>{{ form.departmentName }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
            <v-subheader>Type <span class="red--text">*</span></v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
            <v-select
              v-model="form.type"
              :error-messages="typeErrors"
              required
              outlined
              dense
              flat
              background-color="white"
              :items="typeOptions"
              @input="$v.form.type.$touch()"
              @blur="$v.form.type.$touch()"
              ref="type"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
            <v-subheader>Employees <span class="red--text">*</span></v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
            <v-autocomplete
              v-model="selectedEmployees"
              :error-messages="employeesErrors"
              outlined
              dense
              flat
              multiple
              chips
              small-chips
              deletable-chips
              item-text="name"
              item-value="id"
              return-object
              background-color="white"
              :items="employees"
              @input="$v.selectedEmployees.$touch()"
              @blur="$v.selectedEmployees.$touch()"
              ref="selectedEmployees"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],

  validations: {
    form: {
      type: { required },
    },
    selectedEmployees: { required, minLength: minLength(1) },
  },

  props: {
    form: Object,
  },

  data: () => ({
    selectedEmployees: [],
    typeOptions: ["Cash Advance", "Settlement", "Payment"],
  }),

  computed: {
    typeErrors() {
      const errors = [];
      if (!this.$v.form.type.$dirty) return errors;
      !this.$v.form.type.required && errors.push("Type is required");
      return errors;
    },
    employeesErrors() {
      const errors = [];
      if (!this.$v.selectedEmployees.$dirty) return errors;
      !this.$v.selectedEmployees.required && errors.push("At least one employee is required");
      !this.$v.selectedEmployees.minLength && errors.push("At least one employee is required");
      return errors;
    },
    ...mapState("external", ["employees"]),
  },

  watch: {
    form: {
      handler(val) {
        if (val && val.employees && val.employees.length > 0) {
          this.selectedEmployees = val.employees.map(emp => {
            const found = this.employees.find(e => e.id === emp.employeeId);
            if (found) return found;
            return { id: emp.employeeId, name: emp.employeeName };
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    update() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      const body = {
        id: this.form.id,
        departmentId: this.form.departmentId,
        departmentName: this.form.departmentName,
        type: this.form.type,
        employees: this.selectedEmployees.map(emp => ({
          employeeId: emp.id,
          employeeName: emp.name,
        })),
      };
      this.$store.dispatch("kasbonApproval/update", body);
    },
  },

  mounted() {
    this.$store.dispatch("external/getEmployees");
  },
};
</script>

<style></style>
